module.exports = __webpack_public_path__ + "img/samsung-galaxy-s6 copy.0f3cd269.jpg";